import _asyncToGenerator from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.parse-float.js";
import { __decorate } from "tslib";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Loader } from "google-maps";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

var StoreLocatorDialog = /*#__PURE__*/function (_Vue) {
  _inherits(StoreLocatorDialog, _Vue);

  var _super = _createSuper(StoreLocatorDialog);

  function StoreLocatorDialog() {
    var _this;

    _classCallCheck(this, StoreLocatorDialog);

    _this = _super.apply(this, arguments);
    _this.country = "";
    _this.countryCode = "";
    _this.city = ""; //   map!: google.maps.Map;

    _this.zoomMin = 2;
    _this.stati = [];
    _this.stores = [];
    _this.markers = [];
    _this.clusterStyle = {
      styles: [{
        url: "/images/baseline_radio_button_checked_black_24dp.png",
        width: 48,
        height: 48,
        textSize: 15,
        fontWeight: "bold",
        textColor: "#ffffff",
        textAlign: "center"
      }]
    };
    return _this;
  }

  _createClass(StoreLocatorDialog, [{
    key: "activeStates",
    get: function get() {
      return this.stati.filter(function (stato) {
        return stato.Country;
      });
    }
  }, {
    key: "visible",
    get: function get() {
      return this.open;
    },
    set: function set(v) {
      if (!v) this.$emit("close");
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loader, countries, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.google) {
                  _context.next = 5;
                  break;
                }

                loader = new Loader("AIzaSyAgmUQkC09psxX8EYyCRAW-8ZlB0cGm1uA");
                _context.next = 4;
                return loader.load();

              case 4:
                this.google = _context.sent;

              case 5:
                _context.next = 7;
                return this.$rest.getCountryStoresActive();

              case 7:
                countries = _context.sent;

                for (i = 0; i < countries.data.length; i++) {
                  if (countries.data[i].Country == this.$i18n.locale) {
                    this.country = countries.data[i].NomeStato;
                    this.countryCode = countries.data[i].Country;
                    this.initMap();
                  }
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "initMap",
    value: function initMap() {
      this.map = new this.google.maps.Map(this.$refs.map, {
        zoom: 8,
        minZoom: this.zoomMin,
        maxZoom: 15
      });
    }
  }, {
    key: "setCenterPosition",
    value: function setCenterPosition() {
      var _this2 = this;

      //calcolo la posizione su cui centrare la mappa e relativo zoom
      var geocoder = new this.google.maps.Geocoder();

      if (this.country) {
        if (geocoder) {
          geocoder.geocode({
            address: "".concat(this.city, ", ").concat(this.country)
          }, function (result) {
            _this2.map.fitBounds(result[0].geometry.bounds);
          });
        }
      }
    }
  }, {
    key: "updateStores",
    value: function () {
      var _updateStores = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ccode) {
        var _this3 = this;

        var cn, storesData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cn = this.stati.filter(function (st) {
                  return st.NomeStato == _this3.country;
                })[0];
                ccode = cn ? cn.Country : this.$i18n.locale; // @ts-ignore

                _context2.next = 4;
                return this.$rest.getStores(ccode);

              case 4:
                storesData = _context2.sent;
                this.stores = storesData.data.stores;
                this.stati = storesData.data.countryList;
                this.initMap();
                this.setCenterPosition();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateStores(_x) {
        return _updateStores.apply(this, arguments);
      }

      return updateStores;
    }()
  }, {
    key: "addMapMarkers",
    value: function addMapMarkers() {
      var _this4 = this;

      //reset di eventuali markers precedenti
      if (this.cluster && typeof this.cluster.setMap == "function") {
        this.cluster.clearMarkers();
        this.cluster = new MarkerClusterer({});
      }

      this.markers = []; //inserimento nuovi markers

      for (var i = 0; i < this.stores.length; i++) {
        var m = void 0,
            store = this.stores[i];

        if (store.U_THE_LATITUDINE && store.U_THE_LATITUDINE != "0" && store.U_THE_LONGITUDINE && store.U_THE_LONGITUDINE != "0") {
          // eslint-disable-next-line no-undef
          m = new this.google.maps.Marker({
            position: this.getPosition(store.U_THE_LATITUDINE, store.U_THE_LONGITUDINE),
            map: this.map,
            icon: "/images/pin.png"
          });
          m.storeData = store;
          this.markers.push(m);
        }
      }

      var _loop = function _loop() {
        var PhoneNumber = void 0;
        //   if (this.markers[j].storeData.contatto !== null) {
        var self = _this4,
            m = _this4.markers[j],
            s = m.storeData,
            c = m.storeData;

        if (s.BuildingFloorRoom === "" || s.BuildingFloorRoom == null) {
          NameString = s.U_THE_RAG_SOCIALE;
        } else {
          NameString = s.BuildingFloorRoom;
        }

        if (c.E_Mail === "" || c.E_Mail == null) {
          MailString = "";
        } else {
          MailString = c.E_Mail;
        }

        if (c.Phone1 === "" || c.Phone1 == null) {
          PhoneNumber = "";
        } else {
          PhoneNumber = c.Phone1;
        }

        iw_content = '<div class="card-body white-text">' + '<div class="d-flex row">' + '<div class="col justify-content-center align-items-center info-address-column" style="color: black;">' + '<p class="white-text" >' + "<b>" + NameString + "</b></br>" + '<div class="separator"></div>' + s.Street + ", <br /> " + s.ZipCode + " " + s.City + "<br />" + '<a href="mailto:' + MailString + '" class="contact-data white-text" >' + MailString + "</a><br />" + '<a class="contact-data white-text" href="tel:' + PhoneNumber + '">' + PhoneNumber + "</a>" + "</p>" + "</div>" + // '<div class="col justify-content-center align-items-center info-image-column">'+
        // '<img class="img-fluid store-image '+s.CardCode+s.AddressName+'" onerror="setDefaultImageStore(this)" src="/images/stores_images/'+s.CardCode+s.AddressName+'.jpg" alt="'+s.BuildingFloorRoom+'" />'+
        "</div>" + "</div>" + '<div class="clearfix"></div>' + "</div>";
        var iw = new _this4.google.maps.InfoWindow({
          content: iw_content,
          maxWidth: 350
        });
        m.addListener("click", function () {
          if (typeof _this4.infoWindow != "undefined") {
            _this4.infoWindow.close();
          }

          iw.open(self.map, m);
          _this4.infoWindow = iw;
        });

        _this4.google.maps.event.addListener(iw, "domready", function () {
          var el = document.getElementsByClassName("gm-style-iw")[0],
              wr = el.parentElement,
              // eslint-disable-next-line no-unused-vars
          bk = wr.firstChild,
              // eslint-disable-next-line no-unused-vars
          close = wr.getElementsByTagName("button")[0],
              // eslint-disable-next-line no-unused-vars
          closeIcon = document.createElement("i");
        });
      };

      for (var j = 0; j < this.markers.length; j++) {
        var NameString;
        var MailString;
        var iw_content;

        _loop();
      } // }
      // eslint-disable-next-line no-undef


      this.cluster = new MarkerClusterer({
        map: this.map,
        markers: this.markers
      });
    }
  }, {
    key: "getPosition",
    value: function getPosition(lat, lng) {
      return new this.google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    }
  }, {
    key: "updateMap",
    value: function updateMap(countryCode) {
      this.setCenterPosition();
      this.addMapMarkers();
      this.updateStores(countryCode);
    }
  }, {
    key: "countryChanged",
    value: function countryChanged(newVal) {
      this.updateMap(newVal);
    }
  }, {
    key: "cityChange",
    value: function cityChange(newVal) {
      if (newVal.length >= 3) {
        this.setCenterPosition();
        this.addMapMarkers();
        this.updateStores(this.country);
      }
    } // this.countryChanged()

  }, {
    key: "storesChanged",
    value: function storesChanged() {
      this.addMapMarkers();
    }
  }]);

  return StoreLocatorDialog;
}(Vue);

__decorate([Prop({
  "default": false
})], StoreLocatorDialog.prototype, "open", void 0);

__decorate([Watch("country")], StoreLocatorDialog.prototype, "countryChanged", null);

__decorate([Watch("city")], StoreLocatorDialog.prototype, "cityChange", null);

__decorate([Watch("stores", {
  deep: true
})], StoreLocatorDialog.prototype, "storesChanged", null);

StoreLocatorDialog = __decorate([Component({})], StoreLocatorDialog);
export default StoreLocatorDialog;